import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from '../utils/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Sayfa yenilendiğinde token varsa kullanıcı bilgilerini al
    const token = localStorage.getItem('token');
    if (token) {
      fetchUserInfo();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await axios.get('/auth/me');
      const userData = response.data.user;
      setUser(userData);
      // Kullanıcı bilgilerini localStorage'a kaydet
      localStorage.setItem('user', JSON.stringify(userData));
    } catch (err) {
      console.error('Kullanıcı bilgileri alınamadı:', err);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password) => {
    try {
      setError(null);
      const response = await axios.post('/auth/login', {
        username,
        password
      });
      
      const { token, user: userData } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
      
      return true;
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş sırasında bir hata oluştu');
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const changePassword = async (currentPassword, newPassword) => {
    try {
      setError(null);
      await axios.post('/auth/change-password', {
        currentPassword,
        newPassword
      });
      return true;
    } catch (err) {
      setError(err.response?.data?.error || 'Şifre değiştirme sırasında bir hata oluştu');
      return false;
    }
  };

  const hasPermission = (permission) => {
    // Kullanıcı yoksa yetkisi de yok
    if (!user) return false;
    
    // Admin rolü tüm yetkilere sahip
    if (user.role === 'ADMIN') return true;
    
    // Kullanıcının yetkilerini kontrol et
    return Array.isArray(user.permissions) && user.permissions.includes(permission);
  };

  // Debug için kullanıcı bilgilerini konsola yazdır
  useEffect(() => {
    console.log('Current user:', user);
    console.log('Has USER_MANAGEMENT permission:', hasPermission('USER_MANAGEMENT'));
  }, [user]);

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    changePassword,
    hasPermission
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 